export default __webpack_public_path__ + "static/media/fr.5876a722.svg";